<template>
  <div class="git-area">
    <div class="git-list">
      <div class="gift-item" v-for="(item, i) in list" :key="i">
        <div class="gift-info">{{item.name}} × {{item.number}}</div>
        <a-icon class="gift-remove" type="close-circle" @click="removeGift(i)"/>
      </div>
    </div>
    <div class="flex-box align-center gift-form" v-show="edit">
      <div class="gift-input">
        <a-input v-model="form.name" placeholder="礼品名称"></a-input>
      </div>
      <div class="gift-input">
        <a-input v-model="form.number" placeholder="礼品数量"></a-input>
      </div>
      <div class="flex-box align-center row-btn">
        <div class="txt-btn" @click="confirmAdd">确定</div>
        <div class="txt-btn grey" @click="cancelAdd">取消</div>
      </div>
    </div>
    <a-button @click="showAdd" v-show="!edit"><a-icon type="plus-circle" />添加礼品</a-button>
    <div class="tip gift-tip" v-if="tip">{{tip}}</div>
  </div>
</template>

<script>
    import {clone} from "../../common/js/tool";

    export default {
        name: "gift-list",
        model: {
            event: "change"
        },
        props: {
            value: Array
        },
        data() {
            return {
                form: {},
                edit: false,
                tip: null
            }
        },
        computed: {
            list() {
                const value = this.value;
                return value ? value : [];
            }
        },
        methods: {
            removeGift(i) {
                const list = clone(this.list);
                list.splice(i, 1);
                this.$emit("change", list);
            },
            showAdd() {
                this.form = {};
                this.edit = true;
            },
            confirmAdd() {
                const form = this.form;
                if(!form.name) {
                    this.tip = "请输入礼品名称";
                    return;
                }
                if(!form.number) {
                    this.tip = "请输入礼品数量";
                    return;
                }
                const list = clone(this.list);
                list.push({...form});
                this.$emit("change", list);
                this.cancelAdd();
            },
            cancelAdd() {
                this.tip = null;
                this.edit = false;
            }
        }
    }
</script>

<style lang="less">
  .gift-area {
    position: relative;
  }
  .gift-tip {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(50%);
  }
  .gift-form {
    .gift-input {
      flex: 1;
      margin-right: 10px;
    }
    .row-btn {
      flex-shrink: 0;
    }
  }
  .gift-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 10px;
    height: 40px;
    background-color: @background-color-base;
    line-height: 1.5;
    border-radius: 4px;
  }
  .gift-info {
    flex: 1;
    margin-right: 10px;
  }
  .gift-remove {
    color: @text-color-secondary;
  }
</style>
